module.exports = __webpack_public_path__ + "static/artist-management-the-process-33d62438b730126fec680b2f8127369a.webp";